/* eslint-disable no-param-reassign */
import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Image } from 'components'
import classNames from 'classnames'
import {
  isAnActiveCampaign,
  SALE_CAMPAIGNS,
  replaceCampaignToShow,
} from 'utils/checkCampaign'
import feiraoIcon from 'assets/temporary/feirao/icon/feiraoIcon.png'
import blackout from 'assets/temporary/blackout/icon/blackout.png'
import blackoutDayIcon from 'assets/temporary/blackout/BlackoutDay/icon/blackoutDay.png'
import styles from './Tag.module.scss'

const Tag = ({ children, onClick, campaign = false }) => {
  const greenTags = ['Novidade']
  const isGreenTag = greenTags.includes(children)

  const isFeirao = SALE_CAMPAIGNS.feirao.test(children)

  const isCorujao = SALE_CAMPAIGNS.corujao.test(children)

  const isBlackout = SALE_CAMPAIGNS.blackout.test(children)

  const isBlackoutDay = SALE_CAMPAIGNS.blackoutDay.test(children)

  if (isFeirao && !isAnActiveCampaign(SALE_CAMPAIGNS.feirao)) return null
  if (isCorujao && !isAnActiveCampaign(SALE_CAMPAIGNS.corujao)) return null
  if (isBlackout && !isAnActiveCampaign(SALE_CAMPAIGNS.blackout)) return null
  if (isBlackoutDay && !isAnActiveCampaign(SALE_CAMPAIGNS.blackoutDay))
    return null

  if (
    SALE_CAMPAIGNS.blackout.test(children) ||
    SALE_CAMPAIGNS.blackoutDay.test(children)
  ) {
    children = ''
  }

  children = replaceCampaignToShow(children)

  return (
    <span
      role="button"
      tabIndex={0}
      className={classNames({
        [styles.greenTag]: isGreenTag,
        [styles.deletable]: onClick,
        [styles.primaryTag]: !onClick && campaign,
        [styles.tag]: !campaign && !onClick,
        [styles.feirao]: isFeirao,
        [styles.blackout]: isBlackout,
        [styles.blackoutDay]: isBlackoutDay,
      })}
    >
      {isFeirao && (
        <span className={styles.icon}>
          <Image source={feiraoIcon} />
        </span>
      )}

      {isBlackout && (
        <span
          className={classNames(styles.icon, {
            [styles.blackoutIcon]: isBlackout,
          })}
        >
          <Image source={blackout} />
        </span>
      )}

      {isBlackoutDay && (
        <span
          className={classNames(styles.icon, {
            [styles.blackoutDayIcon]: isBlackoutDay,
          })}
        >
          <Image source={blackoutDayIcon} />
        </span>
      )}

      {campaign ? children.substr(0, 9) : children}
      <b>{campaign && children.substr(10)}</b>
      {onClick && (
        <button type="button" onClick={onClick} className={styles.closeButton}>
          <Icon color="darkColor" type="clear" size={16} />
        </button>
      )}
    </span>
  )
}

Tag.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  campaign: PropTypes.bool,
}

Tag.defaultProps = {
  onClick: null,
  campaign: false,
}

export default React.memo(Tag)
